/**
 * Test Page for Hostname Filtering
 * 
 * Simple test page to verify if hostname filtering is working correctly
 */

import { FC } from 'react';
import { useAgentSelection } from '@/hooks';

const TestHostnamePage: FC = () => {
  const agentSelection = useAgentSelection();

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>🧪 Test Hostname Filter</h1>
      
      <div>
        <label htmlFor="hostname-search">
          Buscar por hostname:
        </label>
        <input
          id="hostname-search"
          type="text"
          placeholder={agentSelection.searchPlaceholder}
          value={agentSelection.searchTerm}
          onChange={(e) => agentSelection.handleSearch(e.target.value)}
          style={{ 
            margin: '10px', 
            padding: '8px', 
            width: '300px',
            border: '1px solid #ccc',
            borderRadius: '4px'
          }}
        />
      </div>

      <div style={{ marginTop: '10px' }}>
        <strong>Ações de teste:</strong>
        <button 
          onClick={() => agentSelection.handleSearch('server')}
          style={{ margin: '5px', padding: '5px 10px' }}
        >
          Buscar "server"
        </button>
        <button 
          onClick={() => agentSelection.handleSearch('localhost')}
          style={{ margin: '5px', padding: '5px 10px' }}
        >
          Buscar "localhost"
        </button>
        <button 
          onClick={() => agentSelection.handleSearch('')}
          style={{ margin: '5px', padding: '5px 10px' }}
        >
          Limpar busca
        </button>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>Estado atual:</h3>
        <ul>
          <li><strong>Search Term:</strong> "{agentSelection.searchTerm}"</li>
          <li><strong>Search Field:</strong> {agentSelection.searchField}</li>
          <li><strong>Loading:</strong> {agentSelection.isLoading ? 'Sim' : 'Não'}</li>
          <li><strong>Total Items:</strong> {agentSelection.totalItems}</li>
          <li><strong>Has Active Filters:</strong> {agentSelection.hasActiveFilters ? 'Sim' : 'Não'}</li>
          <li><strong>Active Filters Count:</strong> {agentSelection.activeFiltersCount}</li>
          <li><strong>Current Page:</strong> {agentSelection.currentPage}</li>
          <li><strong>Page Size:</strong> {agentSelection.pageSize}</li>
        </ul>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h3>Resultados ({agentSelection.entities.length}):</h3>
        {agentSelection.isLoading ? (
          <p>Carregando...</p>
        ) : agentSelection.entities.length === 0 ? (
          <p>Nenhum agente encontrado</p>
        ) : (
          <ul>
            {agentSelection.entities.map((agent) => (
              <li key={agent.id} style={{ marginBottom: '5px' }}>
                <strong>{agent.name}</strong> - {agent.hostname || 'Sem hostname'} 
                ({agent.status || 'offline'})
              </li>
            ))}
          </ul>
        )}
      </div>

      {agentSelection.error && (
        <div style={{ 
          marginTop: '20px', 
          padding: '10px', 
          background: '#ffe6e6', 
          border: '1px solid #ff0000',
          borderRadius: '4px',
          color: '#cc0000'
        }}>
          <strong>Erro:</strong> {agentSelection.error}
        </div>
      )}
    </div>
  );
};

export default TestHostnamePage;